import script from "./CurrenciesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrenciesView.vue?vue&type=script&setup=true&lang=js"

import "./CurrenciesView.vue?vue&type=style&index=0&id=3ea3d5d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea3d5d5"]])

export default __exports__